<template>
  <v-dialog v-model="dialog" class="justify-center layout px-0" max-width="800px">
    <template v-slot:activator="{ on }">
      <mf-button outlined label="Usar termo padrão" v-on:click.native="on.click" />
    </template>
    <v-card>
      <v-card-text>
        <v-row>
          <v-col cols="6" class="pb-0">
            <label class="detail-title">Nome fantasia*</label>
            <v-text-field
              v-model="formatters.fantasy_name"
              class="mb-0"
              outlined
              :error-messages="$v.formatters.fantasy_name.$error ? 'Campo obrigatório.' : ''"
            />
          </v-col>
          <v-col cols="6" class="pb-0">
            <label class="detail-title">Razão social*</label>
            <v-text-field
              v-model="formatters.company_name"
              class="mb-0"
              outlined
              :error-messages="$v.formatters.company_name.$error ? 'Campo obrigatório.' : ''"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="6" class="pb-0">
            <label class="detail-title">Endereço*</label>
            <v-text-field v-model="formatters.address" class="mb-0" outlined :error-messages="$v.formatters.address.$error ? 'Campo obrigatório.' : ''" />
          </v-col>
          <v-col cols="6" class="pb-0">
            <label class="detail-title">CNPJs*</label>
            <v-text-field v-model="formatters.cnpjs" class="mb-0" outlined :error-messages="$v.formatters.cnpjs.$error ? 'Campo obrigatório.' : ''" />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="6" class="pb-0">
            <label class="detail-title">Email*</label>
            <v-text-field v-model="formatters.email" class="mb-0" outlined :error-messages="emailErrorMessage" />
          </v-col>
          <v-col cols="6" class="pb-0">
            <label class="detail-title">Hotsite*</label>
            <v-text-field v-model="formatters.hotsite" class="mb-0" outlined :error-messages="$v.formatters.hotsite.$error ? 'Campo obrigatório.' : ''" />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" class="pb-0">
            <label class="detail-title">Modelo*</label>
            <v-select v-model="selectedModel" :items="models" outlined :error-messages="$v.selectedModel.$error ? 'Campo obrigatório.' : ''" />
          </v-col>
        </v-row>
        <mf-action-buttons
          :primary-button="{
            text: 'Configurar termo',
            action: validateAndSetFields,
            isVisible: true,
          }"
          :extra-button="{
            text: 'Cancelar',
            action: () => (dialog = false),
            isVisible: true,
          }"
        />
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
// eslint-disable-next-line
import TribancoTerm from 'raw-loader!@/modules/configuracoes-admin/assets/terms/tribanco.md'
// eslint-disable-next-line
import MercafacilTerm from 'raw-loader!@/modules/configuracoes-admin/assets/terms/mercafacil.md'
import format from 'string-format'
import { required, email } from 'vuelidate/lib/validators'

export default {
  data: () => ({
    dialog: false,
    formatters: {
      company_name: '',
      fantasy_name: '',
      address: '',
      cnpjs: '',
      email: '',
      hotsite: '',
    },
    selectedModel: '',
    emailErrorMessage: '',
  }),
  computed: {
    models() {
      return [
        { text: 'Modelo Básico Mercafacil', value: 'mercafacil' },
        { text: 'Modelo Básico Tribanco', value: 'tribanco' },
      ]
    },
    modelTerms() {
      return {
        tribanco: TribancoTerm,
        mercafacil: MercafacilTerm,
      }
    },
  },
  methods: {
    setTerm() {
      const term = format(this.modelTerms[this.selectedModel], this.formatters)
      this.$emit('input', term)
      this.dialog = false
    },
    validateAndSetFields() {
      this.$v.$touch()

      if (!this.$v.formatters.email.email && this.$v.formatters.email.$error) {
        this.emailErrorMessage = 'Email inválido.'
      } else if (this.$v.formatters.email.$error) {
        this.emailErrorMessage = 'Campo obrigatório.'
      } else {
        this.emailErrorMessage = ''
      }

      if (this.$v.$error) {
        this.$snackbar({ message: 'Configure os campos corretamente.' })
        return
      }

      this.setTerm()
    },
  },
  validations: {
    selectedModel: { required },
    formatters: {
      company_name: { required },
      fantasy_name: { required },
      address: { required },
      cnpjs: { required },
      email: { required, email },
      hotsite: { required },
    },
  },
}
</script>
